/* eslint-disable */
import React, { useState } from 'react'
import { toast } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import { useViewPort } from '../../src/ViewportProvider.js'
import { COPY_DOWNLOAD_APK_URL, DOWNLOAD_APK_URL } from '../constants'

const DownloadApk = () => {
  const [loading, setLoading] = useState(false)

  const { width } = useViewPort()
  const breakpoint = 376
  const isMobile = width < breakpoint

  const handleDownloadFile = async () => {
    setLoading(true) // Set loading to true before starting the fetch

    const token = localStorage.getItem('token')

    fetch(DOWNLOAD_APK_URL, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error('Error downloading file')
        }
        return response.blob()
      })
      .then((blob) => {
        const url = URL.createObjectURL(blob)
        const a = document.createElement('a')
        a.href = url
        a.download = 'trackspot.apk' // Set the desired file name
        a.click()
        URL.revokeObjectURL(url)
      })
      .catch((error) => {
        window.alert(error)
        console.error('Download error:', error)
      })
      .finally(() => {
        setLoading(false) // Set loading back to false after downloading is complete or an error occurs
      })
  }

  const handleCopyUrl = async () => {
    setLoading(true) // Set loading to true before starting the copy operation

    if (!navigator.clipboard || !navigator.clipboard.writeText) {
      toast.error('Clipboard access not supported, use https')
      setLoading(false) // Set loading back to false if clipboard access is not supported
      return
    }

    // Copy the download URL to clipboard
    navigator.clipboard
      .writeText(COPY_DOWNLOAD_APK_URL)
      .then(() => {
        toast.success('Download URL copied')
      })
      .catch((error) => {
        toast.success('Could Not Copy Link' + error)
      })
      .finally(() => {
        setLoading(false) // Set loading back to false after copying is complete or an error occurs
      })
  }

  return (
    <div
      style={{
        backgroundColor: 'white',
        color: '#007dc6'
      }}
    >
      <div style={{ padding: '1rem 1rem 0rem 1rem' }}>
        <div className="d-flex flex-column">
        {window.location.pathname === '/license' ? (
            <div id="license-title">Licenses</div>
          ): 
          window.location.pathname === '/chat' ?
          (
            <div id="license-title">Chat</div>
          ): (
            <div id="license-title">Data</div>
        )}
          <hr className="licenses-divider" />
          <div className='d-flex justify-content-between align-mock-main-heading'>
            <div className="license-sub-heading mt-2">Mock Application APK</div>
            <div className="download-copy-download-btn">
              {/* Buttons */}
              <div className="d-flex gap-2 btn-alignment-header-login mt-0">
                <button className="btn btn-primary w-50 login-btn-font align-login-with-mobile align-download-web" onClick={handleDownloadFile}>
                  <div>
                    <img
                      className="logo_image google-logo-align"
                      style={{ width: '20px', height: '20px' }}
                      src="images/download-icon.svg"
                      alt="logo"
                      />
                      <span className='ms-2 mock-application-apk-font-family'>
                        Download File
                      </span>
                  </div>
                </button>
                <button
                  className="btn text-white w-50 align-copy-download-link"
                  onClick={handleCopyUrl}
                >
                  <img
                    className="logo_image google-logo-align"
                    style={{ width: '20px', height: '20px' }}
                    src="images/copy-image.svg"
                    alt="logo"
                    />
                    <span className='ms-2 mock-application-apk-font-family'>
                      Copy Download Link
                    </span>
                </button>
              </div>
            </div>
          </div>
          <hr className="licenses-divider" />
        </div>
      </div>
    </div>
  )
}

export default DownloadApk
